// src/source/index.ts
export * from "../interface";
import { default as default2 } from "./vector";
export {
  default2 as VectorSource
};
